export default __webpack_public_path__ + "static/media/bronze.f8e65a7a.svg";